import React, {useState} from 'react';
import {useSelector} from "react-redux";
import useAsyncErrorHandler from "./useAsyncErrorHandler";
import useLoading from "./useLoading";
import * as Async from "../features/async";

export default function useUpdate(config = { returnInnerLoadingState: false }) {
    const credencial = useSelector(state => state.credencial);
    const setLoading = useLoading();
    const asyncErrorHandler = useAsyncErrorHandler();
    const [innerLoading, setInnerLoading] = useState(false);

    const updateFunc = (url, data, onSuccess, onError, shouldFinishLoading = true) => {
        if (typeof onError === 'boolean') {
            shouldFinishLoading = onError;
        }

        config.returnInnerLoadingState ? setInnerLoading(true) : setLoading(true);

        const asyncConfig = {...config};

        delete asyncConfig.returnInnerLoadingState;

        return Async.update(url, credencial, data, asyncConfig)
            .then(data => {
                onSuccess && onSuccess(data);

                return data;
            })
            .catch(error => {
                onError ? onError(error, asyncErrorHandler) : asyncErrorHandler(error);
            })
            .finally(() => {
                config.returnInnerLoadingState ? setInnerLoading(false) : (shouldFinishLoading && setLoading(false));
            });
    }

    return !config.returnInnerLoadingState ? updateFunc : [updateFunc, innerLoading];
}